// import { HandshakeOutlined } from "@mui/icons-material";
// import { Stack, Typography } from "@mui/material";
// import CenteredBox from "./CenteredBox";
//
//
// interface LikelihoodProps {
//   type: "settlement" | "verdict" | "liability";
//   start: number | string;
//   end: number | string;
//   category?: string;
//   unit?: string;
//   icon?: any;
//   showInfoIcon?: boolean;
//   onInfoClick?: () => void;
//   id?: string;
//   infoIconProps?: {
//     textColor?: string;
//     backgroundColor?: string;
//     size?: number;
//     fontSize?: number;
//   };
// }
//
// const Likelihood: React.FC<LikelihoodProps> = ({
//   start,
//   end,
//   type,
//   id,
//   category = "Likelihood",
//   unit = "%",
//   icon = <HandshakeOutlined fontSize="large" />,
//   showInfoIcon,
//   onInfoClick,
//   infoIconProps
// }) => {
//   return (
//     <CenteredBox
//       id={id}
//       icon={icon}
//       title={
//         <Stack direction="row" spacing={1}>
//           <Typography variant="body2" textTransform="capitalize">
//             {type}
//           </Typography>
//           <Typography fontWeight="bold" variant="body2">
//             {category}
//           </Typography>
//         </Stack>
//       }
//       range={{ start: `${start}${unit}`, end: `${end}${unit}` }}
//       // Pass through info button props
//       showInfoIcon={showInfoIcon}
//       onInfoClick={onInfoClick}
//       infoIconProps={infoIconProps}
//     />
//   );
// };
//
// export default Likelihood;


import { HandshakeOutlined } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import CenteredBox from "./CenteredBox";

interface LikelihoodProps {
  type: "settlement" | "verdict" | "defendant liability";
  start: number | string;
  end: number | string;
  category?: string;
  unit?: string;
  icon?: any;
  showInfoIcon?: boolean;
  onInfoClick?: () => void;
  id?: string;
  infoIconProps?: {
    textColor?: string;
    backgroundColor?: string;
    size?: number;
    fontSize?: number;
  };
  // New prop to control whether to show as range or single value
  showAsRange?: boolean;
}

const Likelihood: React.FC<LikelihoodProps> = ({
  start,
  end,
  type,
  id,
  category = "Likelihood",
  unit = "%",
  icon = <HandshakeOutlined fontSize="large" />,
  showInfoIcon,
  onInfoClick,
  infoIconProps,
  // Default to showing as range for backward compatibility
  showAsRange = true,
}) => {
  // Create the title element
  const titleElement = (
    <Stack direction="row" spacing={1}>
      <Typography variant="body2" textTransform="capitalize">
        {type}
      </Typography>
      <Typography fontWeight="bold" variant="body2">
        {category}
      </Typography>
    </Stack>
  );

  // Common props for CenteredBox
  const commonProps = {
    id,
    icon,
    title: titleElement,
    showInfoIcon,
    onInfoClick,
    infoIconProps,
  };

  // If showing as range, use the range prop
  if (showAsRange) {
    return (
      <CenteredBox
        {...commonProps}
        range={{
          start: `${start}${unit}`,
          end: `${end}${unit}`,
        }}
      />
    );
  }

  // If showing as single value, use the value prop
  return (
    <CenteredBox
      {...commonProps}
      value={`${start}${unit}`}
    />
  );
};

export default Likelihood;